var _span;
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class CloseButton extends React.Component {
  render() {
    const {
      label = 'Close',
      onClick
    } = this.props;
    return /*#__PURE__*/_jsxs("button", {
      type: "button",
      className: "close",
      onClick: onClick,
      children: [_span || (_span = /*#__PURE__*/_jsx("span", {
        "aria-hidden": "true",
        children: "\xD7"
      })), /*#__PURE__*/_jsx("span", {
        className: "sr-only",
        children: label
      })]
    });
  }
}
export default CloseButton;